/** Fixed rates for display — source currency → USD */
const TO_USD_RATES = {
  USD: 1,
  GBP: 1.27,
  EUR: 1.08,
};

export function getMarketplaceSourceCurrency(marketplace) {
  const mp = String(marketplace || "").toLowerCase();
  if (mp.includes("ebay")) return "GBP";
  if (mp.includes("vinted")) return "EUR";
  if (mp.includes("poshmark") || mp.includes("shopify")) return "USD";
  return "USD";
}

export function convertPriceToUsd(amount, marketplace) {
  const num = Number(amount);
  if (!Number.isFinite(num)) return null;

  const source = getMarketplaceSourceCurrency(marketplace);
  const rate = TO_USD_RATES[source] ?? 1;
  return Math.round(num * rate * 100) / 100;
}

export function formatUsd(amount) {
  if (amount == null || !Number.isFinite(Number(amount))) return "—";
  return `$${Number(amount).toFixed(2)}`;
}

export function formatOrderItemPriceUsd(price, marketplace, options = {}) {
  const { displayPricePercentage, applyDisplayPriceFn } = options;
  let usd = convertPriceToUsd(price, marketplace);
  if (usd == null) return "—";

  if (typeof applyDisplayPriceFn === "function") {
    usd = applyDisplayPriceFn(usd, displayPricePercentage ?? 100);
  }

  return formatUsd(usd);
}

/** Order #1 → #1001, Order #25 → #1025 */
export function formatDisplayOrderNumber(orderId) {
  const id = Number(orderId);
  if (!Number.isFinite(id)) return String(orderId ?? "");
  return String(1000 + id);
}

export function getOrderDateValue(order) {
  const raw =
    order?.created_at || order?.processing_updated_at || order?.updated_at;
  if (!raw) return null;
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? null : d;
}
